export const LineEndValues = ({ lines }) => {
    if (!lines) return null;

    return lines.map((line, index) => {
        const points = line.props.points;
        if (!points || !points.length) return null;

        const last = points[points.length - 1];
        const name = line.item?.props?.dataKey;
        const color = line.item?.props?.stroke;

        return (
            <text
                key={`label-${name}-${index}`}
                x={last.x + 8}
                y={last.y}
                textAnchor="start"
                dominantBaseline="middle"
                fill={color}
                fontSize={14}
                fontWeight={500}
                style={{ pointerEvents: "none" }}
            >
                {last.value}
            </text>
        );
    });
};
